import React from 'react'
import { Link } from 'react-router-dom'

const HomeMain = () => {
  return (
  <div id='website-responsive' >
    <div className='bg-img4' style={{ backgroundImage:'url("/home/ULC-Home-Banner-v1.jpg")', width:'100%', height:'100%'}}>
    <div className='home-text-padding'>
        <div className='-max-width display-none'>
            <text className='fs-ss-52 text-montserrat fw-700 lh-1-2 text-ss-primary' style={{ letterSpacing:'-1px'}}>
                IMPROVING THE <br/> HEALTH OF THE <br/> COMMUNITY
            </text>
        </div>

        <div className='display-none-1150 py-4'>
            <text className='fs-ss-20 text-montserrat text-ss-primary fw-500 ' style={{ letterSpacing:'0.5px'}}>
                We offer <strong> Drug </strong> testing, <strong> Blood </strong> testing, <strong> STD </strong>,
                <br/>
                <strong>Covid-19, RSV, Influenza, </strong> and <strong> Respiratory </strong>
                <br/>
                <strong> Pathogen Panel </strong> testing services
                <br/>
                throughout the <strong> Chicagoland Area! </strong>
            </text>
        </div>

        <div className='-max-width display-block1 lh-1-2 pt-3'>
            <text className='fs-ss-15 text-montserrat fw-700 lh-1 text-ss-primary' style={{ letterSpacing:'-1px'}}>
                Taking the Community <br/>
                forward by improving <br/>
                Healthcare
                </text>
            </div>

        <div className='pt-4 display-none'>
        <button className='my-2 border-0 btn-ss-white-banner ms-0 rounded20' style={{ width:'', boxShadow:'1px 1px 5px 0 rgba(0,0,0,.5)'}}>
        <div  className='flex-center '>
            {/* <TelephoneFill className='fs-ss-17' /> */}
            <Link to='/walk-in-appointment' className='fs-ss-14 text-montserrat fw-700 text-white' style={{ textTransform:'uppercase', textDecoration:'none'}}>Walk-in Appointment </Link>
        </div>
        </button>
        </div>

        <div className='pt-3 display-block1'>
        <Link to='/walk-in-appointment' className='text-montserrat fw-700 text-white' style={{ fontSize:'9px', textTransform:'uppercase', textDecoration:'none'}}>
        <button className='my-2 border-0 btn-ss-white-banner ms-0 rounded20' style={{ width:'', boxShadow:'1px 1px 5px 0 rgba(0,0,0,.5)'}}>
        <div  className='flex-center '>
            {/* <TelephoneFill className='fs-ss-17' /> */}
         Walk-in Appointment 
        </div>
        </button>
        </Link>
        </div>
    </div>
    </div>
</div>
  )
}

export default HomeMain